module.exports = __webpack_public_path__ + "img/confirm.50018906.jpg";